import Sidebar from './SideBar.vue';

const SidebarStore = {
  options: null,
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');
    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(() => {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  },
  reload() {
    if (this.options && this.options.sidebarLinks) {
      if (typeof this.options.sidebarLinks === 'function') {
        this.sidebarLinks = this.options.sidebarLinks.call(this.options.vm);
      } else {
        this.sidebarLinks = this.options.sidebarLinks;
      }
    }
  },
};

const SidebarPlugin = {

  install(Vue, options) {
    SidebarStore.options = options;
    SidebarStore.reload();
    Vue.mixin({
      data() {
        return {
          sidebarStore: SidebarStore,
        };
      },
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get() {
        return this.$root.sidebarStore;
      },
    });
    Vue.component('side-bar', Sidebar);
  },
};

export default SidebarPlugin;



// WEBPACK FOOTER //
// ./src/components/UIComponents/SidebarPlugin/index.js